import {BotReportingEventObject} from "../../types/chat";

export class ReportingEventFactory {
    static create(
        messageId: string,
        responseId: string,
        url: string,
        subscriberId: number,
        userSessionId: string,
        trademark: string,
        client: string
    ): BotReportingEventObject {

        let event = 'deep-link';
        if(url.indexOf(".pdf") !== -1) {
            event = 'file-link';
        } else if(url.includes('/public/hilfe_und_informationen')
            || url.includes('/help/hilfe_und_informationen') ) {
            event = 'article-link';
        }

        const createdAt = new Date(Date.now());
        return {
            type: "MessageEvent",
            messageId: messageId,
            id: responseId,
            event: event,
            url: url,
            client: client,
            subscriberId: subscriberId,
            userSessionId: userSessionId,
            trademark: trademark,
            createdAt: createdAt.toISOString()
        };
    }
}